const whitelist = {
  ALLOWED_TAGS: ['strong', 'em', 'u', 'p', 'br', 'ul', 'li', 'ol'],
  ALLOWED_ATTR: ['class'],
};

export default whitelist;
